///<reference path='../../typings/index.d.ts' />
///<reference path='../config.ts' />
///<reference path='../manifest/assets.ts' />

module agi.expressions.card.controller {
    import EventBus       = agi.expressions.event.EventBus;
    import AudioData      = agi.expressions.AudioData;
    import AudioPlayer    = agi.expressions.AudioPlayer;
    import AssetsManifest = agi.expressions.card.manifest.AssetManifest;

    export class AudioController {
        protected assetManifest:AssetsManifest; 
        protected audioUrls:Array<Array<string>>;
        protected audioPlayer:AudioPlayer;
        protected music:HTMLAudioElement;
        protected howl:Howl;
        protected loadedCallback:any;
        protected eventBus:EventBus = EventBus.getInstance();

        public sfxLoaded = false;
        public audioOn:boolean = true;

        constructor (assets:AssetsManifest){
            this.assetManifest = assets;
            this.audioUrls = this.assetManifest.audioUrls;

            this.eventBus.addEventListener("nextTrack", this.nextTrack.bind(this));
            this.eventBus.addEventListener("playMusic", this.resume.bind(this));
            this.eventBus.addEventListener("pauseMusic", this.pause.bind(this));
            this.eventBus.addEventListener("playSFX", this.playSFX.bind(this));
        }

        public load(callback:Function){
            this.loadedCallback = callback;
            this.assetManifest.sfxData.onload = ()=>{
                this.sfxLoaded = true;
                this.loadedCallback();
            }

            var audioData:AudioData = <AudioData>{};
            this.howl = new Howl(this.assetManifest.sfxData);
            this.music = this.createAudioTag(this.assetManifest.musicData);
            audioData.trackData = this.assetManifest.musicData;
            audioData.trackInstance = this.music;
            audioData.loop = this.assetManifest.musicData.loop;
            audioData.extraBuffer = 0.5;
            this.audioPlayer = new AudioPlayer(audioData);
            document.body.appendChild(this.music);
        }

        public playTracks():void {
            this.audioOn = true;
            this.audioPlayer.playTracks();
        }

        public restart():void {
            this.howl.stop();
            if (this.audioOn){
                this.audioPlayer.restart();
            }
        }

        public stop():void {
            this.audioPlayer.stop();
            this.howl.stop();
        }

        public pause():void {
            this.audioOn = false;
            this.audioPlayer.pause();
            Howler.mute(true);
        }

        public resume():void {
            this.audioOn = true;
            this.audioPlayer.resume();
            Howler.mute(false);
        }

        protected createAudioTag(musicData:IHowlProperties):HTMLAudioElement{
            var audio:HTMLAudioElement = document.createElement("audio");
            audio.controls = false;
            for (var i=0; i<musicData.src.length; i++){
                var source:HTMLSourceElement = document.createElement("source");
                source.src = musicData.src[i];
                audio.appendChild(source);
            }

            return audio;
        }

        protected nextTrack(event):void {
            this.audioPlayer.nextTrack();
        }

        protected playSFX(event:any):void {
            var sfx = event.sfx;
            if(sfx)
                this.howl.play(sfx);
        }
    }
}
